<template>
  <ClientOnly>
    <div v-if="isReady && showConsentWarning && !isHidden" class="flex items-center justify-center p-2">
      <div class="text-center">
        <p>{{ name }} is disabled because you haven't consented to non-essential cookies.</p>
        <BaseButton class="mt-8" label="Consent" to="KETCH" size="SMALL">Update Preferences</BaseButton>
      </div>
    </div>
    <template v-else-if="!showConsentWarning && isReady">
      <slot></slot>
    </template>
  </ClientOnly>
</template>

<script setup lang="ts">
const { $ketch } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const showConsentWarning = ref(true)
const isReady = ref(false)
const { name, isHidden } = defineProps<{
  name: String
  isHidden?: boolean // if true, the component will not show the consent warning
}>()

onMounted(() => {
  if (isIntegrationEnabled('ketch')) {
    $ketch.onConsentResolved(() => {
      isReady.value = true
      if ($ketch.hasConsent.value) {
        showConsentWarning.value = false
      } else {
        showConsentWarning.value = true
      }
    })
  } else {
    isReady.value = true
    showConsentWarning.value = false
  }
})
</script>
